import React, { useState } from "react";
import LcFetch from "lib/shared/fetch";

const Banner = ({
  confirmedBannerUrl,
  bannerKey,
  confirmButtonText = "Confirm"
}) => {
  const [showBanner, setShowBanner] = useState(true);

  const messages = {
    maintenance_jun2025_banner: `LitCharts will be undergoing planned maintenance and will be unavailable
   for a brief time on Tuesday, June 10.`,
    privacy_policy_banner: `We have updated our <u><a href="/privacy">Privacy Policy</a></u>.
    By continuing to use our site, you confirm that you have read our updated Privacy Policy.`
  };

  const confirmButton = (e) => {
    e.preventDefault();
    const requestUrl = `${confirmedBannerUrl}?banner_key=${bannerKey}`;
    LcFetch(requestUrl, {
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
      },
      method: "PATCH"
    }).then(() => {
      setShowBanner(false);
    });
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div id={bannerKey} className="sitewide-banner-container">
      <div className="sitewide-banner">
        <div>
          <div className="banner-1 content-container">
            <span dangerouslySetInnerHTML={{ __html: messages[bannerKey] }} />
            <button
              type="button"
              onClick={confirmButton}
              className="btn btn-default btn-sm confirm-button"
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
